import { useCallback, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useQueryClient } from 'react-query'

import { addTraderContactAPI } from 'api/corporate-contacts'
import { AddTraderContactTypes, CorporateContactFormTypes } from 'types/corporateContacts'

const INITIAL_VALUES: CorporateContactFormTypes = {
  traderId: 0,
  contactId: undefined,
  titleId: 1,
  firstName: '',
  lastName: '',
  middleNames: '',
  phone1: '',
  phone2: '',
  fax1: '',
  fax2: '',
  email: '',
  mobile: '',
  comments: '',
  isPrimary: true,
  isActive: true,
}

export const useAddCorporateContact = (onCloseModal: () => void) => {
  const { traderId } = useParams()
  const queryClient = useQueryClient()
  const corporateTraderId = Number(traderId) || 0

  const [initialValues, initialValuesSet] = useState<CorporateContactFormTypes>({
    ...INITIAL_VALUES,
    traderId: corporateTraderId,
  })

  const isLoading = useMemo(() => false, [])

  const handleSubmitAddCorporateContact = useCallback(
    async (values: CorporateContactFormTypes) => {
      const payload: AddTraderContactTypes = {
        traderId: corporateTraderId,
        titleId: values.titleId,
        firstName: values.firstName,
        lastName: values.lastName,
        middleNames: values.middleNames,
        phone1: values.phone1,
        phone2: values.phone2,
        fax1: values.fax1,
        fax2: values.fax2,
        email: values.email,
        mobile: values.mobile,
        comments: values.comments,
        isPrimary: values.isPrimary,
        isActive: values.isActive,
      }

      try {
        await addTraderContactAPI(payload)
        toast.success('Contact added successfully.')
        queryClient.invalidateQueries({ queryKey: ['useCorporateContacts'] })
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(message.outcomeUserMessage || 'Failed to add contact.')
      }
    },
    [corporateTraderId, onCloseModal, queryClient]
  )

  return {
    initialValues,
    isLoading,
    handleSubmitAddCorporateContact,
  }
}
